<template>
<form @submit.prevent="saveNewItem" novalidate ref="form" class="pop-up-content flex flex-col align-start">
	<form-field-set id="formContent" v-if="!confirmMsg" :legend-text="introText.heading">
		<template #fields>
			<TextArea
				ref="ua_description"
				name="ua_description"
				:value="formData.ua_description"
				@emitFieldData="(val) => formData.ua_description = val"
				:min-chars="0"
				:max-chars="2000"
				label-text="Description of Item"
				required-error="Please provide a description"
				:validation-rules="[(v) => rules.containsLength(v, 3, 2000)]" />

			<DateTextField
				class="cols-full"
				label-text="Purchase Date"
				ref="ua_purchasedate"
				name="ua_purchasedate"
				:value="formData.ua_purchasedate"
				@emitFieldData="(val) => formData.ua_purchasedate = val"
				max-date="today"
				:help-text="{text: 'please enter in the following format: DD/MM/YYYY'}"
				:validation-rules="[rules.isValidDate, rules.beforeMaxDate]" />

			<InputField
				name="ua_serialnumber"
				ref="ua_serialnumber"
				label-text="Serial Number"
				:value="formData.ua_serialnumber"
				@emitFieldData="(val) => formData.ua_serialnumber = val"
				:max-chars="200"
				:validation-rules="[(v) => rules.containsLength(v, 0, 200)]" />

			<NumberField
				ref="ua_price"
				name="ua_price"
				:value="formData.ua_price"
				@emitFieldData="(val) => formData.ua_price = val"
				:help-text="{text: 'Currency in GBP'}"
				label-text="Price (£)"
				:step="0.01"
				icon="icon-pound"
				invalid-number="Please enter a number in pounds and pence" />

			<NumberField
				ref="ua_lifespanyears"
				name="ua_lifespanyears"
				:value="formData.ua_lifespanyears"
				@emitFieldData="(val) => formData.ua_lifespanyears = val"
				label-text="Life Span (Years)"
				:step="1"
				invalid-number="Please enter the number of years" />

			<TextArea
				ref="ua_location"
				name="ua_location"
				:value="formData.ua_location"
				@emitFieldData="(val) => formData.ua_location = val"
				:min-chars="0"
				:max-chars="2000"
				label-text="Location"
				:validation-rules="[(v) => rules.containsLength(v, 1, 2000)]" />

			<div class="actions cols-full flex space-between m-t-2 m-b-2">
				<Button class="secondary" text="Cancel" button-type="button" @btnClick="confirmCancel" />
				<Button class="primary" text="Save Asset Details" button-type="submit" />
			</div>
		</template>
	</form-field-set>
	<div v-show="confirmMsg" class="confirm-message flex flex-col wrap align-center justify-center">
		<Heading :level="2" text="Are you sure you want to cancel?" classes="m-b-1" />
		<p class="m-b-2">You will lose any changes made to this item</p>

		<div class="actions cols-full flex wrap justify-center m-t-2">
			<Button class="primary" text="No, take me back." button-type="button" @btnClick="confirmMsg = false" />
			<Button class="secondary" text="I'm sure, cancel." button-type="button" @btnClick="$emit('finished')" />
		</div>
	</div>
</form>
</template>

<script>
// Please see childEntityPopUp mixin for common settings
import { childEntityPopUp } from '@/mixins/childEntityPopUp';

export default {
	mixins: [childEntityPopUp],

	data () {
		return {
			formData: {
				ua_description: '',
				ua_purchasedate: '',
				ua_serialnumber: '',
				ua_price: '',
				ua_lifespanyears: '',
				ua_location: '',
				ua_icclaim: this.$route.params.claimId
			},
			introText: {
				heading: 'Add Asset Details'
			}
		};
	},

	mounted () {
		if (this.getCurrentItemByType) {
			this.formData = this.getCurrentItemByType;

			this.introText.heading = 'Edit Asset Details';
		}
	}
};
</script>
